import { ICollectionResponse } from "../../models/ICollectionResponse";
import { IBackgroundTask } from "../../models/Tasks";
import api from "../Api";

const tasksEndpoints = api.injectEndpoints({
    endpoints: (build) => ({
        getBackgroundTasks: build.query<ICollectionResponse<IBackgroundTask>, void>({
            query: () => '/tasks/background'
        })
    }),
    overrideExisting: false,
});

export const {
    useGetBackgroundTasksQuery,
} = tasksEndpoints;